import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { TooltipContainer, TooltipText, TooltipFloating } from './style';

export const getTooltipPosition = (
  clientX: number,
  clientY: number,
  content: string,
  maxWidth = 360,
  rowHeight = 22,
  padding = 16,
  targetRect?: DOMRect,
  maxHeight = 280,
  verticalGap = 4,
) => {
  const items = content.split('\n')
  const numLines = items.length
  const estimatedHeight = Math.min(500, Math.max(40, numLines * rowHeight + padding))
  const tooltipHeight = Math.min(estimatedHeight, maxHeight)

  let left: number
  let top: number

  if (targetRect) {
    const tooltipWidth = Math.min(maxWidth, window.innerWidth - 16)
    left = targetRect.left
    if (left + tooltipWidth > window.innerWidth) {
      left = Math.max(8, window.innerWidth - tooltipWidth - 8)
    }
    if (left < 8) left = 8

    top = targetRect.top - tooltipHeight - verticalGap

    if (top < 8) {
      top = targetRect.bottom + verticalGap
      if (top + tooltipHeight > window.innerHeight) {
        top = Math.max(8, window.innerHeight - tooltipHeight - 8)
      }
    }
    console.debug('getTooltipPosition result', { left, top, tooltipWidth, tooltipHeight })
  } else {
    left = clientX + 10
    if (left + maxWidth > window.innerWidth) {
      left = Math.max(8, window.innerWidth - maxWidth - 8)
    }

    top = clientY - 10
    if (top + estimatedHeight > window.innerHeight) {
      top = clientY - estimatedHeight - 10
    }
    if (top < 8) {
      top = 8
    }
  }

  return { x: left, y: top }
}

interface TooltipProps {
  text: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <TooltipContainer
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && text && <TooltipText>{text}</TooltipText>}
    </TooltipContainer>
  );
};

interface FloatingTooltipProps {
  visible: boolean;
  x: number;
  y: number;
  children: React.ReactNode;
}

export const FloatingTooltip: React.FC<FloatingTooltipProps> = ({ visible, x, y, children }) => {
  if (!visible) return null

  return ReactDOM.createPortal(
    <TooltipFloating style={{ left: x, top: y }}>
      {children}
    </TooltipFloating>,
    document.body,
  )
}

export default Tooltip; 